import { makeStyles } from "@material-ui/core/styles";
import { IMAGE_SIZE } from "./constants";
import { h7Regular } from "../../shared/typography";
import { withOpacity } from "../../shared/mixins";

export const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },

  image: {
    width: IMAGE_SIZE,
    height: IMAGE_SIZE,
    borderRadius: 6,
    objectFit: "cover",
    flexShrink: 0,
  },

  overflowBadge: {
    width: IMAGE_SIZE,
    height: IMAGE_SIZE,
    borderRadius: 6,
    background: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    ...h7Regular,
    ...withOpacity(0.56),
  },
}));
